export enum OAuthVariants {
  VK = 1,
  Google = 2,
  Facebook = 3,
  Instagram = 4,
  Odnoklassniki = 5,
  Apple = 6,
  Telegram = 7,
}
